<template>
    <div>
        <UiCardListHeader
            :title="lang('auctions::auctions.widgets.current.title')"
            :action-href="route('auctions.admin.index')"
            :action-label="lang('auctions::auctions.actions.manage')"
        />

        <UiCardEmpty v-if="auctions.length === 0">
            {{ lang('auctions::auctions.widgets.current.no_auctions') }}
        </UiCardEmpty>
        <UiCardList
            v-else
            as="transition-group"
            name="slide-fade"
            enter-active-class="transition duration-300 ease-out transform"
            enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-20"
            enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <auction-preview v-for="auction in auctions" :key="auction.id" :auction="auction"></auction-preview>
        </UiCardList>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import AuctionPreview from '@src/Auctions/Pages/Preview.vue';

const auctions: Ref<[]> = ref([]);

const load = () => {
    axios.get(route('auctions.admin.api.current')).then(({ data }) => {
        auctions.value = data.auctions ?? [];
    });
};

window.Echo.channel('admin')
    .listen('.auction.started', () => {
        load();
    })
    .listen('.auction.updated', () => {
        load();
    })
    .listen('.auction.created', () => {
        load();
    })
    .listen('.auction.ended', () => {
        load();
    })
    .listen('.auction.stopped', () => {
        load();
    });

load();
</script>
